import { Invoice } from './types';
import { v4 as uuidv4 } from 'uuid';

const KEY = 'invoices_v1';

export function loadInvoices(): Invoice[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as Invoice[];
    return parsed;
  } catch (e) {
    console.error('loadInvoices error', e);
    return [];
  }
}

export function saveInvoices(list: Invoice[]) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (e) {
    console.error('saveInvoices error', e);
  }
}

export function seedSample(): Invoice[] {
  const sample: Invoice = {
    id: uuidv4(),
    customer: 'ACME Corporation',
    date: new Date().toISOString().slice(0, 10),
    items: [
      { id: uuidv4(), description: 'Design work', qty: 5, price: 100 },
      { id: uuidv4(), description: 'Development', qty: 12, price: 80 },
    ],
    notes: 'Thanks for your business',
  };
  // don't persist here; return sample for app to set if desired
  return [sample];
}
